module.exports = __webpack_public_path__ + "static/digital-service-87d9689ae750f5aa058cb32ea67085cf.png";